import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20fashion%20collage%20with%20bold%20terracotta%20coral%20sage%20green%20and%20sand%20tones%20overlapping%20shapes%20fashion%20silhouettes%20minimalist%20artistic%20composition%20editorial%20style%20clean%20lines%20modern%20aesthetic%20warm%20inviting%20atmosphere%20negative%20space%20for%20text%20placement&width=1920&height=1080&seq=hero-bg-v2-kkb-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet product directory lifestyle"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        {/* Left: Text */}
        <div className="w-full lg:w-3/5 text-center lg:text-left">
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-[1.08] tracking-tight">
            Kakobuy Spreadsheet
            <br />
            <span className="text-white/85 font-light italic">The Ultimate Product</span>
            <br />
            <span className="text-white/90">Directory &amp; Guide 2026</span>
          </h1>
          <p className="mt-5 md:mt-6 text-white/80 text-base md:text-lg max-w-lg mx-auto lg:mx-0 leading-relaxed font-light">
            Discover verified products, trusted sellers, buying guides, and the latest spreadsheet finds — all in one place.
          </p>

          {/* Trust badges */}
          <div className="mt-6 flex flex-wrap gap-3 justify-center lg:justify-start">
            <span className="px-4 py-1.5 rounded-full bg-white/15 text-white text-xs md:text-sm font-medium backdrop-blur-sm whitespace-nowrap">
              Updated Daily
            </span>
            <span className="px-4 py-1.5 rounded-full bg-white/15 text-white text-xs md:text-sm font-medium backdrop-blur-sm whitespace-nowrap">
              Safe Buying Tips
            </span>
            <span className="px-4 py-1.5 rounded-full bg-white/15 text-white text-xs md:text-sm font-medium backdrop-blur-sm whitespace-nowrap">
              Beginner Friendly
            </span>
          </div>

          {/* CTA Buttons */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm md:text-base hover:bg-white/90 transition-all duration-200 whitespace-nowrap text-center"
            >
              Browse Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full border-2 border-white text-white font-semibold text-sm md:text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap text-center"
            >
              Visit Official Store
            </a>
          </div>
        </div>

        {/* Right: decorative product image */}
        <div className="hidden lg:block w-full lg:w-2/5">
          <div className="relative w-full aspect-[3/4] max-w-[380px] mx-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Vertical%20editorial%20photograph%20of%20a%20single%20premium%20designer%20handbag%20on%20white%20marble%20surface%20with%20delicate%20gold%20accents%20soft%20studio%20lighting%20luxury%20minimal%20aesthetic%20crisp%20shadows%20refined%20composition%20elegant%20sophisticated%20style&width=800&height=1067&seq=hero-side-v2-kkb-2026&orientation=portrait"
              alt="Kakobuy Spreadsheet curated fashion products"
              className="w-full h-full object-cover rounded-2xl"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}